import { cn } from '@/utils/tailwind-merge';

export default function P({
    children,
    className,
    weight = 'regular',
    color = 'black',
}: {
    // TODO: Remove React.ReactNode
    children: string | React.ReactNode;
    className?: string;
    weight?: 'regular' | 'light' | 'medium';
    color?: 'blue' | 'white' | 'black' | 'brand-white';
}) {
    return (
        <p
            className={cn(
                color === 'black' && 'text-black',
                color === 'blue' && 'text-classicBlue',
                color === 'white' && 'text-white',
                color === 'brand-white' && 'text-brandTofu',
                'max-lg:text-sm lg:text-p font-helveticaNeue tracking-[-0.36px] leading-none',
                weight === 'regular' && 'font-normal',
                weight === 'light' && 'font-light',
                weight === 'medium' && 'font-medium',
                className,
            )}
        >
            {children}
        </p>
    );
}
